import { UserGroupsApiFactory } from '@eloomi/eloomi-user-groups-persona-client/1.0';

import { authorizeClient } from '@/api/authorize-client';

const userGroupsApiClient = authorizeClient(UserGroupsApiFactory);

export function deleteGroupsBulk(ids: number[]) {
    return userGroupsApiClient.deleteBulk(ids);
}
